// Keep in sync with proxy.ts - `matcher` must list all locales explicitly as a static string (no interpolation allowed).
export const APP_LOCALES = ['en'] // TODO: Add more locales when LOCALIZATION_ENABLED is set to true ('es', 'fr', 'de')
export const APP_DEFAULT_LOCALE = 'en'

export const LOCALE_TRANSLATION = {
	en: 'English',
	es: 'Español',
	fr: 'Français',
	de: 'Deutsch',
}
